"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageService = exports.browserTypes = exports.deviceTypes = void 0;
/* eslint-disable @typescript-eslint/ban-types */
const webexUI_1 = require("webexUI");
exports.deviceTypes = {
    iPhone: 'iPhone',
    iPad: 'iPad',
    android: 'android',
    desktop: 'desktop',
};
exports.browserTypes = {
    ie: 'ie',
    edge: 'edge',
    firefox: 'firefox',
    safari: 'safari',
};
class PageService {
    constructor() {
        this.deviceType = exports.deviceTypes.desktop;
        this.browserType = null;
        this.onWindowResizeHandlers = [];
        this.onWindowResizeThrottleHandlers = [];
        this.onBodyClickHandlers = [];
        this.onPopStateHandlers = [];
        this.onScrollThrottleHandlers = [];
        this.onHashChangeHandlers = [];
        this.onPageLoadHandlers = [];
        this.onTouchStartHandlers = [];
        this.onTouchEndHandlers = [];
        this.ieClass = 'ie-active';
        this.edgeClass = 'edge-active';
        this.ffClass = 'ff-active';
        this.safariClass = 'safari-active';
        this.iPhoneClass = 'iphone-active';
        this.iPadClass = 'ipad-active';
        this.androidClass = 'android-active';
        this.touchStartHelper = (event) => {
            this.onTouchStartHandlers.forEach(handler => {
                handler(event);
            });
        };
        this.touchEndHelper = () => {
            this.onTouchEndHandlers.forEach(handler => {
                handler();
            });
        };
    }
    Init() {
        this.$window = $(window);
        this.$document = $(document);
        this.$body = $(document.body);
        this.DetectBrowser();
        this.DetectDeviceType();
    }
    AddOnHashChangeHandler(handler) {
        this.onHashChangeHandlers.push(handler);
    }
    AddOnPageLoadHandler(handler) {
        this.onPageLoadHandlers.push(handler);
    }
    AddOnWindowResizeHandler(handler) {
        this.onWindowResizeHandlers.push(handler);
    }
    AddOnWindowResizeThrottleHandler(handler) {
        this.onWindowResizeThrottleHandlers.push(handler);
    }
    AddOnBodyClickHandler(handler) {
        this.onBodyClickHandlers.push(handler);
    }
    AddOnScrollThrottleHandler(handler) {
        this.onScrollThrottleHandlers.push(handler);
    }
    AddOnTouchStartHandler(handler) {
        this.onTouchStartHandlers.push(handler);
    }
    AddOnTouchEndHandler(handler) {
        this.onTouchEndHandlers.push(handler);
    }
    AttachOnTouchStartHandler() {
        if (this.onTouchStartHandlers.length) {
            this.$document.on('touchstart', this.touchStartHelper);
        }
    }
    AttachOnTouchEndHandler() {
        if (this.onTouchEndHandlers.length) {
            this.$document.on('touchend', this.touchEndHelper);
        }
    }
    AttachOnScrollThrottleHandler() {
        if (this.onScrollThrottleHandlers.length) {
            this.$document.on('scroll', (0, webexUI_1.throttle)(e => {
                this.ScrollThrottleHelper(e);
            }, 50));
        }
    }
    AttachOnHashChangeHandler() {
        if (this.onHashChangeHandlers.length) {
            this.$window.on('hashchange', this.hashChangeHelper.bind(this));
        }
    }
    AttachOnPageLoadHandler() {
        if (this.onPageLoadHandlers.length) {
            this.$window.on('load', this.pageLoadHelper.bind(this));
        }
    }
    AttachOnBodyClickHandlers() {
        this.onBodyClickHandlers.length && this.$body.on('click tap', this.BodyClickHelper.bind(this));
    }
    AddOnPopStateHandler(handler) {
        this.onPopStateHandlers.push(handler);
    }
    AttachOnPopStateHandlers() {
        if (this.onPopStateHandlers.length > 0) {
            window.onpopstate = event => {
                this.onPopStateHandlers.forEach(handler => {
                    handler(event);
                });
            };
        }
    }
    AttachOnWindowResizeHandlers() {
        this.onWindowResizeHandlers.length &&
            this.$window.on('resize', (0, webexUI_1.debounce)(() => {
                this.WindowResizeHelper();
            })) &&
            this.WindowResizeHelper();
    }
    AttachOnWindowResizeThrottleHandlers() {
        this.onWindowResizeThrottleHandlers.length &&
            this.$window.on('resize', (0, webexUI_1.throttle)(() => {
                this.WindowResizeThrottleHelper();
            }));
    }
    DetectBrowser() {
        const ua = window.navigator.userAgent;
        // eslint-disable-next-line no-useless-escape
        const isIE = ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./);
        const isEdge = ua.indexOf('Edge') > -1;
        const isFF = ua.search('Firefox') > -1;
        const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
        if (isIE) {
            this.$body.addClass(this.ieClass);
            this.browserType = exports.browserTypes.ie;
        }
        else if (isEdge) {
            this.$body.addClass(this.edgeClass);
            this.browserType = exports.browserTypes.edge;
        }
        else if (isFF) {
            this.$body.addClass(this.ffClass);
            this.browserType = exports.browserTypes.firefox;
        }
        else if (isSafari) {
            this.$body.addClass(this.safariClass);
            this.browserType = exports.browserTypes.safari;
        }
    }
    DetectDeviceType() {
        const ua = window.navigator.userAgent.toLowerCase();
        const isiPad = ua.indexOf('ipad') > -1;
        const isiPhone = ua.indexOf('iphone') > -1;
        const isAndroid = ua.indexOf('android') > -1;
        if (isiPad) {
            this.deviceType = exports.deviceTypes.iPad;
            this.$body.addClass(this.iPadClass);
        }
        else if (isiPhone) {
            this.deviceType = exports.deviceTypes.iPhone;
            this.$body.addClass(this.iPhoneClass);
        }
        else if (isAndroid) {
            this.deviceType = exports.deviceTypes.android;
            this.$body.addClass(this.androidClass);
        }
    }
    WindowResizeHelper() {
        this.windowWidth = this.$window.width();
        this.onWindowResizeHandlers.forEach(handler => {
            handler(this.windowWidth);
        });
    }
    WindowResizeThrottleHelper() {
        this.windowWidth = this.$window.width();
        this.onWindowResizeThrottleHandlers.forEach(handler => {
            handler(this.windowWidth);
        });
    }
    BodyClickHelper(event) {
        this.onBodyClickHandlers.forEach(handler => {
            handler(event);
        });
    }
    ScrollThrottleHelper(event) {
        this.onScrollThrottleHandlers.forEach(handler => {
            handler(event);
        });
    }
    hashChangeHelper(event) {
        this.onHashChangeHandlers.forEach(handler => {
            handler(event);
        });
    }
    pageLoadHelper() {
        this.onPageLoadHandlers.forEach(handler => {
            handler();
        });
    }
}
const service = new PageService();
exports.PageService = service;
